import * as React from 'react'
import { inject, observer } from 'mobx-react'
import styled from 'styled-components'
import { media } from 'src/utils.js'
import { StoreProps } from 'src/stores'
import MobileOverview from './MobileConfiguratorOverview'
import ModalClientDetails from './ModalClientDetails'

const NumberFormat = require('react-number-format')

type Props = StoreProps

@inject('confStore')
@observer
export default class BottomNavigation extends React.Component<Props, any> {
  timeout: NodeJS.Timeout

  constructor(props) {
    super(props)
    const { confStore } = props
    this.state = {
      priceDisplayed: confStore.offerProductTotal(),
      overviewOpen: false,
      clientDetailsOpen: false
    }
  }

  toggleOverview = (open: boolean) => {
    this.setState({ overviewOpen: open })
  }

  toggleClientDetails = (open: boolean) => {
    this.setState({ clientDetailsOpen: open })
  }

  adjustPrice = () => {
    clearTimeout(this.timeout)
    const { confStore } = this.props
    const { priceDisplayed } = this.state
    const totalPrice = confStore.offerProductTotalWithDiscounts()
    const diff = Math.abs(Math.floor(totalPrice) - Math.floor(priceDisplayed))
    if (diff > 23) {
      this.timeout = setTimeout(
        () =>
          this.setState({
            priceDisplayed:
              totalPrice > priceDisplayed
                ? priceDisplayed + 27 * (Math.floor(diff / 250) + 1)
                : priceDisplayed - 27 * (Math.floor(diff / 250) + 1)
          }),
        10
      )
    } else if (totalPrice !== priceDisplayed) {
      this.timeout = setTimeout(
        () => this.setState({ priceDisplayed: totalPrice }),
        10
      )
    }
  }

  render() {
    const { priceDisplayed, overviewOpen, clientDetailsOpen } = this.state

    this.adjustPrice()
    return (
      <Container>
        <PriceContainer>
          <p>
            Total:{' '}
            <NumberFormat
              value={priceDisplayed}
              displayType='text'
              thousandSeparator='.'
              decimalSeparator=','
              prefix='€ '
              decimalScale={2}
              fixedDecimalScale={!Number.isInteger(+priceDisplayed)}
            />
          </p>
        </PriceContainer>
        <UserButton onClick={() => this.toggleClientDetails(true)}>
          <i className='fas fa-ellipsis-v'></i>
        </UserButton>
        <CartButton href='#overview' onClick={() => this.toggleOverview(true)}>
          <i className='fas fa-shopping-cart'></i>
        </CartButton>
        <MobileOverview
          open={overviewOpen}
          onClose={() => this.toggleOverview(false)}
        />
        <ModalClientDetails
          open={clientDetailsOpen}
          onClose={() => this.toggleClientDetails(false)}
        />
      </Container>
    )
  }
}

const Container = styled.div`
  display: none;
  ${media.giant`
    display: block;
  `}
  position: fixed;
  bottom: 15px;
  right: 7%;
  width: 60%;
  height: 65px;
  margin: 0;
  z-index: 999;
  background: #a7c9cd;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  ${media.largePhone`
    bottom: 0;
    right: 0;
    width: 100%;
    height: 65px;
    margin: 0;
    box-shadow: none;
  `}
`

const CartButton = styled.a`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: -30px;
  width: 70px;
  height: 70px;
  padding: 15px 7.5px;
  border-radius: 100%;
  background: #974353;
  font-size: 30px;
  color: #eaeaea;
  text-align: center;

  &:hover,
  &:visited {
    color: #eaeaea;
  }

  ${media.largePhone`
    top: calc(-40% + 5px);
    right: 30px;
    transform: none;
    width: 60px;
    height: 60px;
    font-size: 25px;
  `}
`

const UserButton = styled.div`
  position: absolute;
  top: 50%;
  left: 30px;
  width: 40px;
  height: 40px;
  padding: 7.5px;
  border-radius: 100%;
  transform: translateY(-50%);
  font-size: 20px;
`

const PriceContainer = styled.div`
  position: absolute;
  width: 100%;
  top: 50%;
  transform: translateY(-50%);

  p {
    margin: 0;
    font-size: 18px;
    font-weight: bold;
    text-align: center;
  }
`



// WEBPACK FOOTER //
// ./src/components/organisms/configurator/BottomNavigation.tsx